import React from 'react';
import { TextField, Stack, IconButton } from '@mui/material';
import { Search as SearchIcon, Clear as ClearIcon } from '@mui/icons-material';

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  onClear: () => void;
  placeholder?: string;
}

/**
 * Reusable search bar component
 */
export const SearchBar: React.FC<SearchBarProps> = ({
  value,
  onChange,
  onClear,
  placeholder = 'Search...',
}) => {
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <SearchIcon sx={{ color: '#64748b' }} />
      <TextField
        fullWidth
        size="small"
        placeholder={placeholder}
        value={value}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
        sx={{
          '& .MuiOutlinedInput-root': {
            backgroundColor: '#ffffff',
            '& fieldset': {
              borderColor: '#e2e8f0',
            },
            '&:hover fieldset': {
              borderColor: '#3b82f6',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#3b82f6',
            },
          },
        }}
      />
      {value && (
        <IconButton size="small" onClick={onClear} sx={{ color: '#64748b' }}>
          <ClearIcon fontSize="small" />
        </IconButton>
      )}
    </Stack>
  );
};

export default SearchBar;
